module.exports = __webpack_public_path__ + "img/creative-commons-pd-alt.f243d6eb.svg";